import React from "react";

function InvoiceIcon({ className, fill }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
    >
      <path d="M13.5 9.74995C13.5 9.33574 13.1642 8.99995 12.75 8.99995H6.75C6.33579 8.99995 6 9.33574 6 9.74995C6 10.1642 6.33579 10.5 6.75 10.5H12.75C13.1642 10.5 13.5 10.1642 13.5 9.74995Z" />
      <path d="M12.5 12.75C12.5 12.3357 12.1642 12 11.75 12H6.75C6.33579 12 6 12.3357 6 12.75C6 13.1642 6.33579 13.5 6.75 13.5H11.75C12.1642 13.5 12.5 13.1642 12.5 12.75Z" />
      <path d="M12.75 15C13.1642 15 13.5 15.3357 13.5 15.75C13.5 16.1642 13.1642 16.5 12.75 16.5H6.75C6.33579 16.5 6 16.1642 6 15.75C6 15.3357 6.33579 15 6.75 15H12.75Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 21.75H19C20.5188 21.75 21.75 20.5187 21.75 19V13.5C21.75 13.0857 21.4142 12.75 21 12.75H17.75V4.94315C17.75 3.51975 16.1411 2.69178 14.9828 3.51912L14.8078 3.64415C14.0273 4.20164 12.9701 4.19977 12.1859 3.63966C10.8821 2.70833 9.11794 2.70833 7.81407 3.63966C7.02992 4.19977 5.9727 4.20164 5.19221 3.64415L5.01717 3.51912C3.8589 2.69178 2.25 3.51975 2.25 4.94315V18C2.25 20.071 3.92893 21.75 6 21.75ZM8.68593 4.86026C9.46825 4.30146 10.5318 4.30146 11.3141 4.86026C12.6161 5.79028 14.3739 5.79739 15.6796 4.86475L15.8547 4.73972C16.0202 4.62153 16.25 4.73981 16.25 4.94315V19C16.25 19.4501 16.3581 19.8749 16.5499 20.25H6C4.75736 20.25 3.75 19.2426 3.75 18V4.94315C3.75 4.73981 3.97984 4.62153 4.14531 4.73972L4.32036 4.86475C5.62605 5.79739 7.3839 5.79028 8.68593 4.86026ZM17.75 19V14.25H20.25V19C20.25 19.6903 19.6904 20.25 19 20.25C18.3096 20.25 17.75 19.6903 17.75 19Z"
      />
    </svg>
  );
}

export default InvoiceIcon;
